import { cloneDeep } from "lodash";
import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../../app/common-components/Button";
import { configurationApi } from "../../../../../app/services/configurationApi";
import { effciencyApi } from "../../../../../app/services/efficiencyApi";
import { useCommonAlert } from "../../../../../app/utilities/helpers";
import "../styles.scss";
import AccessTable from "./AccessTable";



const JenkinRoles = () => {
  const [RoleState, setState] = useState({
    tableHeader: [],
    subHeaders: [],
    tableBody: {},
  });
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const { state } = useLocation();
  const navigate = useNavigate();

  const row = state?.row;
  const [getGroups] = effciencyApi.useLazyGetGroupsQuery();
  const [getAccessDetailsById] =
    configurationApi.useLazyGetAccessDetailsByIdQuery();
  const [saveConfig] = configurationApi.useSaveConfigMutation();
  const jenkinsjob=["Build","Cancel","Discover","Read","Workspace","Delete","Create"];
  const jenkinsrun = ["Ready"];
  const jenkinsview = ["Read"];

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    const access = e.target.value;
    let clonedState = cloneDeep(RoleState);
    let splitArray = access.split("_");

        
      const selectedArray = clonedState.tableBody[splitArray[0]].map((data) => {
        if (data.value === splitArray[1]) {
          data = {
            ...data,
            [name]: value,
          };
          return data;
        }
        return data;
      });
      setState((state) => ({
        ...state,
        tableBody: {
          ...state.tableBody,
          [splitArray[0]]:selectedArray
        },
      }));
    
  };

  const mapObject = (data, parentObject, tool, role) => {
    let grpObject = {};
    data.forEach((grp) => {
      let fieldPresent = false;
      Object.keys(parentObject).forEach((key) => {
        if (key === grp.groups) {
          parentObject[key].forEach((access) => {
            const splitArray = access.split("_");
            if (
              splitArray[0] === role.toUpperCase() &&
              tool.toUpperCase() === splitArray[1]
            ) {
              fieldPresent = true;
              grpObject[key] = true;
            }
          });
        }
      });
      if (!fieldPresent) {
        grpObject[grp.groups] = false;
      }
    });
    return grpObject;
  };
  const getGroup = async () => {
    const { data } = await getGroups();
    const accessData = await getAccessDetailsById(row.id);
    const tableHeader = [
      [
        {
          key: 1,
          text: "Categories",
          rowSpan: "2",
          colSpan: "1",
        },
        {
          key: 2,
          text: "Permissions",
          rowSpan: "2",
          width: "25%",
        },
        {
          key: 2,
          text: "Role",
          colSpan: data.length,
          className: "text-center",
        },
      ],
    ];
    const subHeaders = data.map((grp, idx) => ({
      key: idx,
      text: grp.groups,
    }));
    tableHeader.push(subHeaders);
    const parentObject = accessData?.isSuccess
    ? JSON.parse(accessData?.data.permission)
    : {};
      const jenkinsJob = jenkinsjob.map((tool) => {
        const tmpdata = mapObject(data, parentObject, tool, "job");
        return {
          category: "Job",
          value: tool,
          className: "text-center toolbit_confic",
          ...tmpdata,
        };
      });
      const jenkinsRun = jenkinsrun.map((tool) => {
        const tmpdata = mapObject(data, parentObject, tool, "run");
        return {
          category: "Run",
          value: tool,
          className: "text-center toolbit_confic",
          ...tmpdata,
        };
      });
      const jenkinsView = jenkinsview.map((tool) => {
        const tmpdata = mapObject(data, parentObject, tool, "view");
        return {
          category: "Ready",
          value: tool,
          className: "text-center toolbit_confic",
          ...tmpdata,
        };
      });
      setState((state) => ({
        ...state,
        tableHeader,
        subHeaders,
        tableBody: {
          job:jenkinsJob, 
          run:jenkinsRun,
          view:jenkinsView },
      }));
    
  };
  const getPermission = () => {
    const devopsToolGroups = {};
    Object.keys(RoleState.tableBody).forEach((key) => {
      RoleState.tableBody[key].forEach((item) =>
        Object.keys(item).forEach((key) => {
          if (item[key] === true) {
            devopsToolGroups[key] = devopsToolGroups[key]
              ? devopsToolGroups[key]
              : [];
            devopsToolGroups[key].push(
              `${item.category.toUpperCase()}_${item.value.toUpperCase()}`
            );
          }
        })
      );
    });
    return devopsToolGroups;
  };

  const cancelConfig = () => {navigate("/configuration/administration/tools");};
  const saveConfiguration = () => {
    localStorage.removeItem("toolsCurrentPage");
    localStorage.removeItem("isConfigClicked");
    const permissionData = getPermission();
    const { id, toolName, type, userName, password, url, apiToken, sslValue } =
      row;
    const payload = {
      devopsToolGroups: JSON.stringify(permissionData, null, 4),
      toolId: row.id,
      tools: {
        id,
        toolName,
        type,
        userName,
        password,
        url,
        apiToken,
        sslValue,
      },
    };
    saveConfig({ payload,userName }).then((data) => {
      if (data.error.originalStatus === 201) {
        callCommonAlert("success",data.error.data);
        hideCommonAlert();
        setTimeout(() => navigate("/configuration/settings/tools"),2000);
      } else {
        callCommonAlert("error", "Jenkins role configuration failed to save");
        hideCommonAlert();
      }
    });

  };
  useEffect(() => {
    if(state === null){
      navigate("/configuration/settings/tools");
      return;
    }
    getGroup();
  }, []);

  return (
    <>
      <div className="grid-table">
        <AccessTable
          tableHeaders={RoleState.tableHeader}
          body={RoleState.tableBody}
          onChange={(e) => handleOnChange(e)}
        />
      </div>
      <div className="btnwrap config_btn">
        <Button
          text="Cancel"
          className={"cancelBtnStyle btn btn-primary-btn"}
          onClick={(e) => {
            e.preventDefault();
            cancelConfig();
          }}
        />
        <Button
          text="Save"
          className={"btnStyle btn btn-primary-btn"}
          onClick={(e) => {
            e.preventDefault();
            saveConfiguration();
          }}
        />
      </div>
    </>
  );
};

export default memo(JenkinRoles);
